module.exports = __webpack_public_path__ + "static/media/arrow-down.98a00401.svg";